import React, { useEffect, useState } from 'react'
import api from '../components/api'
import { dataTableRender } from '../components/functions'

const CombustaoMovel = (props) => {

    const ano = props.ano
    const adesao_institucional_id = props.adesao_institucional_id
    const [resultado, setResultado] = useState()




    async function carregaDados() {

        await api.get(`GHG_EfluentesOperacao/${adesao_institucional_id}/${ano}`).then((result) => {

            

            setResultado(result.data.map((rs) =>
            
                <tr>
                    <td>{rs.tratamentoAnaerobico}</td>
                    <td>{rs.quantidadeEfluenteLiquido}</td>
                    <td>{rs.componenteDegradavelEfluente}</td>
                    <td>{rs.unidade}</td>
                    <td>{rs.quantidadeNitrogenio}</td>
                    <td>{rs.fatorEmissaoN2O}</td>
                    <td>{rs.nitrogenioIodoInventario}</td>
                    <td>{rs.tratamentoAplicadoEfluente}</td>
                    <td>{rs.fatorConversaoMetano}</td>
                    <td>{rs.quantidadeCH4}</td>
                    <td>{rs.destinoBiogasRecuperado}</td>
                    
                </tr>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })

    }



    useEffect(() => {

        carregaDados()

    }, [adesao_institucional_id, ano])



    useEffect(() => {


        //dataTableRender('dataTableExampleClima')


    }, [])


    return (

        <div>

            
                <table id="dataTableExampleClima" className="table table-bordered table-striped table-hover">
                    <thead>
                        <tr>
                            <th tyle={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Tratamento Anaerobico
                                </center>

                            </th>
                            <th style={{ backgroundColor: '#bab6b6'}}> 

                                <center>
                                Qtde. Efluente Liq.
                                </center>

                            </th>
                        
                            
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Comp. Degradavel Efluente
                                </center>

                            </th>

                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Unid.
                                </center>

                            </th>


                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Qtde. nitrog&ecirc;nio
                                </center>

                            </th>

                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Fator emissao NO<sup>2</sup>
                                </center>

                            </th>
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Nitrog. Iodo Inventario
                                </center>

                            </th>
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Trat. Aplic. Efluente
                                </center>

                            </th>
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Fator Convers. Metano
                                </center>

                            </th>
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Qtde CH<sup>4</sup>
                                </center>

                            </th>
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Destino Biogas Recup.
                                </center>

                            </th>

                            

                            
                        </tr>
                        
                    </thead>
                    <tbody>
                        {resultado}
                    </tbody>
                    
                </table>    



        </div>
    )

}


export default CombustaoMovel